

const Loading = () => {

    return (
        <div class="flex items-center justify-center p-24">
            <div class="w-16 h-16 border-4 border-transparent border-t-orange-500 border-l-orange-700 rounded-full animate-spin"></div>
        </div>

    )
}
export default Loading